<template>
  <div class="i-list-item">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'list-item'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/list/list-item.vue